;; Copyright (C) 2022, Doctor Evidence. All rights reserved.

(ns dre.shared.interface.names
  "Maps of custom human readable names")


(def categories
  {"medline" "PubMed"
   "cord19" "CORD-19"
   "clinicaltrials" "ClinicalTrials.gov"
   "epar" "EMA EPAR"
   "dailymed" "FDA DailyMed"
   "who-ictrp" "WHO ICTRP"
   "doc-congress" "Congresses"
   "doc-congress-dev" "CongressesDev"
   "pmc" "PubMed Central"
   "embase" "Embase"
   "ccc" "Current Contents Connect"
   "science-direct" "ScienceDirect"
   "nih" "NIH Grants"
   "patent" "Patents"
   "epar-pdf" "EPAR Documents"})

(def docsearch-tags
  (array-map
    "DEM" "Demographics"
    "CON" "Condensates"
    "THE" "Therapeutic Procedure"
    "GEN" "Gene or Genome"
    "DIS" "Disease & Disorders"
    "INJ" "Injury"
    "SYM" "Symptom"
    "CHE" "Chemical"
    "DRU" "Drug"
    "VIT" "Vitamin"
    "ANT" "Antibiotic"
    "VIR" "Virus"
    "CEL" "Cell"
    "ANA" "Anatomy"
    "MED" "Medical Devices"
    "BAC" "Bacteria"
    "SPE" "Species"
    "DIA" "Diagnostic Procedure"
    "LAB" "Lab Procedure"
    "MOL" "Biomolecular research"
    "PRO" "Procedure"
    "PHY" "Physiology"
    "BIO" "Biologic Function"
    "PHE" "Phenomena"
    "TST" "Lab test result"
    "ORG" "Medical Organization"
    "OCC" "Medical Occupation"
    "FOD" "Food"))

(def curated-tag-labels
  {"animal" "Animal"
   "in-vitro" "In-Vitro"
   "non-clinical-study" "Non-clinical study"
   "review-or-meta-analysis" "Review/Meta Analysis"
   "retractions-or-errata" "Retractions/Errata"
   "diagnosis-accuracy" "Diagnosis Accuracy"})

(def pubmed-pubtype
  "See pubtype task in bb.edn."
  {"D000068036" "Graphic Novel",
   "D000068397" "Clinical Study",
   "D000069520" "Blog",
   "D000072438" "Calendar",
   "D000072643" "Study Guide",
   "D000073843" "Equivalence Trial",
   "D000076362" "Adaptive Clinical Trial",
   "D000076942" "Preprint",
   "D000077202" "Dispensatory",
   "D000077522" "Clinical Trial, Veterinary",
   "D000077803" "Dictionary, Classical",
   "D000077823" "Dictionary, Medical",
   "D000077824" "Dictionary, Dental",
   "D000077825" "Dictionary, Pharmaceutic",
   "D000077844" "Dictionary, Chemical",
   "D000077862" "Manuscript, Medical",
   "D000078182" "Systematic Review",
   "D000078323" "Observational Study, Veterinary",
   "D000078325" "Clinical Trial Protocol",
   "D000078903" "Catalog, Drug",
   "D000078922" "Catalog, Union",
   "D000078925" "Catalog, Commercial",
   "D000078928" "Formulary, Homeopathic",
   "D000078929" "Formulary, Hospital",
   "D000078930" "Pharmacopoeia, Homeopathic",
   "D000078942" "Web Archive",
   "D000078984" "Formulary, Dental",
   "D000080871" "Movable Books",
   "D000081262" "Randomized Controlled Trial, Veterinary",
   "D002363" "Case Reports",
   "D002378" "Catalog, Bookseller",
   "D002382" "Catalog, Publisher",
   "D003160" "Comparative Study",
   "D004020" "Dictionary, Polyglot",
   "D006801" "Human-related",
   "D016221" "Festschrift",
   "D016416" "Meeting Abstract",
   "D016417" "Bibliography",
   "D016418" "Legal Case",
   "D016419" "Classical Article",
   "D016420" "Comment",
   "D016421" "Editorial",
   "D016422" "Letter",
   "D016423" "Congress",
   "D016424" "Overall",
   "D016425" "Published Erratum",
   "D016426" "Scientific Integrity Review",
   "D016427" "Technical Report",
   "D016428" "Journal Article",
   "D016429" "Clinical Conference",
   "D016430" "Clinical Study",
   "D016431" "Guideline",
   "D016433" "News",
   "D016435" "Directory",
   "D016437" "Dictionary",
   "D016438" "Duplicate Publication",
   "D016439" "Corrected and Republished Article",
   "D016440" "Retraction of Publication",
   "D016441" "Retracted Publication",
   "D016446" "Consensus Development Conference",
   "D016447" "Consensus Development Conference, NIH",
   "D016448" "Multicenter Study",
   "D016449" "Randomized Controlled Trial",
   "D016453" "Periodical Index",
   "D016454" "Review",
   "D016456" "Historical Article",
   "D016467" "Monograph",
   "D017065" "Practice Guideline",
   "D017203" "Interview",
   "D017418" "Meta-Analysis",
   "D017426" "Clinical Trial, Phase I",
   "D017427" "Clinical Trial, Phase II",
   "D017428" "Clinical Trial, Phase III",
   "D017429" "Clinical Trial, Phase IV",
   "D018431" "Newspaper Article",
   "D018486" "Twin Study",
   "D018848" "Controlled Clinical Trial",
   "D019215" "Biography",
   "D019477" "Portrait",
   "D019478" "Academic Dissertation",
   "D019479" "Account Book",
   "D019480" "Advertisement",
   "D019482" "Almanac",
   "D019484" "Address",
   "D019486" "Animation",
   "D019487" "Annual Report",
   "D019488" "Architectural Drawing",
   "D019490" "Broadside",
   "D019492" "Caricature",
   "D019493" "Cartoon",
   "D019494" "Catalog",
   "D019497" "Diary",
   "D019499" "Documentaries and Factual Films",
   "D019500" "Encyclopedia",
   "D019502" "Ephemera",
   "D019504" "Eulogy",
   "D019505" "Funeral Sermon",
   "D019508" "Guidebook",
   "D019509" "Herbal",
   "D019514" "Instructional Film and Video",
   "D019517" "Unedited Footage",
   "D019519" "Poster",
   "D019523" "Sermon",
   "D019525" "Price List",
   "D019527" "Prospectus",
   "D019528" "Lecture Note",
   "D019531" "Lecture",
   "D019532" "Map",
   "D019539" "Pharmacopoeia",
   "D019542" "Program",
   "D019991" "Database",
   "D020463" "Abbreviations",
   "D020465" "Anecdotes",
   "D020466" "Atlas",
   "D020467" "Biobibliography",
   "D020468" "Chart",
   "D020469" "Chronology",
   "D020470" "Collected Work",
   "D020471" "Collection",
   "D020472" "Drawing",
   "D020474" "Essay",
   "D020475" "Examination Questions",
   "D020476" "Exhibition",
   "D020478" "Form",
   "D020479" "Handbook",
   "D020480" "Wit and Humor",
   "D020481" "Index",
   "D020482" "Juvenile Literature",
   "D020484" "Laboratory Manual",
   "D020485" "Legislation",
   "D020486" "Manuscript",
   "D020488" "Nurses Instruction",
   "D020489" "Outline",
   "D020490" "Patent",
   "D020492" "Periodical",
   "D020493" "Autobiography",
   "D020494" "Phrases",
   "D020495" "Pictorial Work",
   "D020496" "Popular Work",
   "D020497" "Problems and Exercises",
   "D020498" "Programmed Instruction",
   "D020500" "Statistics",
   "D020501" "Tables",
   "D020502" "Terminology",
   "D020503" "Union List",
   "D020504" "Abstracts",
   "D020505" "Collected Correspondence",
   "D020507" "Resource Guide",
   "D022902" "Unpublished Work",
   "D022903" "Government Publication",
   "D022921" "Book Review",
   "D022922" "Fictional Work",
   "D022923" "Textbook",
   "D023361" "Validation Study",
   "D023362" "Evaluation Study",
   "D029282" "Patient Education Handout",
   "D054519" "Aphorisms and Proverbs",
   "D054710" "Interactive Tutorial",
   "D054711" "Introductory Journal Article",
   "D055821" "Poetry",
   "D055823" "Cookbook",
   "D055824" "Formulary",
   "D056571" "Postcard",
   "D057213" "Incunabula",
   "D057405" "Webcast",
   "D059036" "Photograph",
   "D059040" "Video-Audio Media",
   "D062210" "Personal Narrative",
   "D064886" "Dataset",
   "D064888" "Observational Study",
   "D065007" "Pragmatic Clinical Trial",
   "D066309" "Public Service Announcement",
   "RWE" "Real World Evidence",
   "DRUG_UTILIZATION_POSTFILTER" "Treatment Patterns",
   "HEALTHCARE_UTILIZATION_POSTFILTER" "Healthcare Economics",
   "NATURAL_HISTORY_POSTFILTER" "Epidemiology",
   "RISK_POSTFILTER" "Risk/Prognosis",
   "SAFETY_POSTFILTER" "Efficacy/Safety"
   "INCIDENCE_PREVALENCE" "Incidence/Prevalence"
   "FINAL-REPORT" "Final Report"
   "PROTOCOL" "Protocol"
   "STATISTIC-ANALYSIS-PLAN" "Statistic Analysis Plan"
   "STUDY-OUTLINE" "Study Outline"
   "PREDICTED-D016449" "Randomized Clinical Trial"})
